import React from 'react';
import { Download } from 'lucide-react';
import { LOGOS, PALETTE, FONTS, VOICE, SAMPLE, hexToRgb, rgbToCmyk } from './brandKitData';

export const KIT = '/brand/kit';

export const Section = ({ id, no, title, children }) => (
  <section className="bk-section" data-testid={`brandkit-section-${id}`}>
    <div className="bk-section-head"><span>{no}</span><h2>{title}</h2></div>
    {children}
  </section>
);

export const LogoCard = ({ logo }) => (
  <div className="bk-logo" data-testid={`brandkit-logo-${logo.id}`}>
    <div className={`bk-logo-stage ${logo.square ? 'bk-square' : ''}`} style={{ background: logo.bg }}>
      <img src={`${KIT}/${logo.svg}`} alt={`AudiNexa ${logo.title}`} />
    </div>
    <div className="bk-logo-meta">
      <div><h3>{logo.title}</h3><p>{logo.note}</p></div>
      <a className="bk-btn" href={`${KIT}/${logo.png}`} download data-testid={`brandkit-download-png-${logo.id}`}>
        <Download size={15} /> Download PNG
      </a>
    </div>
  </div>
);

export const Swatch = ({ c }) => {
  const rgb = hexToRgb(c.hex);
  const cmyk = rgbToCmyk(rgb);
  const light = rgb[0] * 0.299 + rgb[1] * 0.587 + rgb[2] * 0.114 > 200;
  return (
    <div className="bk-swatch" data-testid={`brandkit-swatch-${c.hex.slice(1)}`}>
      <div className={`bk-chip ${light ? 'bk-chip-light' : ''}`} style={{ background: c.hex }} />
      <h4>{c.name}</h4>
      <dl>
        <dt>HEX</dt><dd data-testid={`brandkit-hex-${c.hex.slice(1)}`}>{c.hex}</dd>
        <dt>RGB</dt><dd>{rgb.join(', ')}</dd>
        <dt>CMYK</dt><dd>{cmyk.join(', ')}</dd>
      </dl>
      <p>{c.use}</p>
    </div>
  );
};

export const Palette = () => PALETTE.map((g) => (
  <div key={g.group} className="bk-palette-group">
    <h3>{g.group} <small>{g.note}</small></h3>
    <div className="bk-swatches">{g.colours.map((c) => <Swatch key={c.hex} c={c} />)}</div>
  </div>
));

export const Typography = () => FONTS.map((f) => (
  <div key={f.family} className="bk-font" data-testid={`brandkit-font-${f.family.replace(/\s+/g, '-').toLowerCase()}`}>
    <div className="bk-font-head">
      <h3 style={{ fontFamily: f.css }}>{f.family}</h3>
      <p>{f.role} · {f.source}</p>
    </div>
    {f.weights.map((w) => (
      <div key={w.w + w.use} className="bk-font-row">
        <div className="bk-font-label"><strong>{w.label}</strong><span>{w.use}</span></div>
        <p style={{ fontFamily: f.css, fontWeight: w.w }} className={w.small ? 'bk-sample-sm' : 'bk-sample'}>{SAMPLE}</p>
      </div>
    ))}
  </div>
));

export const Voice = () => (
  <div className="bk-voice" data-testid="brandkit-voice">
    {VOICE.map((v) => <p key={v}>{v}</p>)}
  </div>
);

export const Logos = () => <div className="bk-logos">{LOGOS.map((l) => <LogoCard key={l.id} logo={l} />)}</div>;
